import { gql } from '@apollo/client';
const TENANT_ELEMENT = gql `
  fragment TenantElementFragment on ModelSpecificationTemplateElementNode {
    id
    name
  }
`;
export default TENANT_ELEMENT;
